import { gebc, addClass, removeClass } from "@qneyraud/q-utils";

const DEFAULT_OPTIONS = {
  threshold: 0,
  offsetTop: 0,
  once: false,
  inViewClass: "in-view"
};

class ObservedElement {
  constructor(el, options = DEFAULT_OPTIONS) {
    this.el = el;
    this.options = {
      ...DEFAULT_OPTIONS,
      ...this.getOptionsFromDataset(),
      ...options
    };
    this.observer = null;
    this.events = {};

    this.observerCallback = this.observerCallback.bind(this);

    this.createObserver();
    this.observer.observe(this.el);
  }

  createObserver() {
    this.observer = new window.IntersectionObserver(this.observerCallback, {
      threshold: this.options.threshold,
      rootMargin: `0px 0px ${-this.options.offsetTop}px 0px`
    });
  }

  getOptionsFromDataset() {
    const options = {};
    if (this.el.dataset && this.el.dataset.threshold) options.threshold = parseFloat(this.el.dataset.threshold);
    if (this.el.dataset && this.el.dataset.offsettop) options.offsetTop = parseInt(this.el.dataset.offsettop);

    return options;
  }

  observerCallback(intersections) {
    if (intersections[0].isIntersecting) {
      addClass(this.el, this.options.inViewClass);
      this.emit("enter", {
        el: this.el,
        options: this.options
      });

      if (this.options.once) {
        this.observer.disconnect();
      }
    } else {
      removeClass(this.el, this.options.inViewClass);
      this.emit("leave", {
        el: this.el,
        options: this.options
      });
    }
  }

  on(event, cb) {
    this.events[event] = cb;
    return this;
  }

  emit(event, datas) {
    if (this.events[event]) this.events[event](datas);
  }
}

class ObservedElementCollection {
  constructor() {
    this.children = [];
  }

  on(event, cb) {
    this.children.forEach((child) => {
      child.on(event, cb);
    });
    return this;
  }
}

const preprocessElementsArgument = (elements) => {
  if (typeof elements === "string") {
    return Array.from(document.querySelectorAll(elements));
  } else if (elements instanceof window.HTMLCollection) {
    return Array.from(elements);
  } else if (elements instanceof window.HTMLElement) {
    return [elements];
  }

  return elements;
};

export const observe = (elements, options) => {
  elements = preprocessElementsArgument(elements);

  const collection = new ObservedElementCollection();

  elements.forEach((el) => {
    const a = new ObservedElement(el, { ...options, once: false });

    collection.children.push(a);
  });

  return collection;
};

export const observeOnce = (elements, options) => {
  elements = preprocessElementsArgument(elements);

  const collection = new ObservedElementCollection();

  elements.forEach((el) => {
    const a = new ObservedElement(el, { ...options, once: true });

    collection.children.push(a);
  });

  return collection;
};

export const observeChildren = (parent, options) => {
  const observe = gebc(parent, "observe", true)
    .concat(parent.classList.contains("observe") ? parent : [])
    .map((el) => new ObservedElement(el, { ...options, once: false }));

  const observeOnce = gebc(parent, "observe-once", true)
    .concat(parent.classList.contains("observe-once") ? parent : [])
    .map((el) => new ObservedElement(el, { ...options, once: true }));

  return observe.concat(observeOnce);
};

export default {
  observe,
  observeOnce,
  observeChildren
};



// WEBPACK FOOTER //
// ./scripts/lib/helpers/observer.js